import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiLinkedin, FiGlobe, FiHeart } = FiIcons;

const Footer = () => {
  return (
    <footer id="kontakt" className="bg-gray-900 text-white py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {/* About Section */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">JJ</span>
              </div>
              <div>
                <h3 className="text-xl font-bold">Jonas Jaani</h3>
                <p className="text-gray-400 text-sm">IT-konsult & AI-expert</p>
              </div>
            </div>
            <p className="text-gray-300 leading-relaxed">
              Erfaren IT-konsult med passion för AI och teknisk innovation. 
              Hjälper företag och individer att navigera i den digitala transformationen.
            </p>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h4 className="text-lg font-semibold mb-4">Snabblänkar</h4>
            <ul className="space-y-2">
              <li>
                <a href="https://www.jonasjaani.se" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-blue-400 transition-colors flex items-center space-x-2">
                  <span>JonasJaani.se</span>
                  <SafeIcon icon={FiGlobe} className="w-4 h-4" />
                </a>
              </li>
              <li>
                <a href="mailto:jonas@jonasjaani.se" className="text-gray-300 hover:text-blue-400 transition-colors">
                  Kontakt
                </a>
              </li>
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <h4 className="text-lg font-semibold mb-4">Följ mig</h4>
            <div className="space-y-3">
              <a href="mailto:jonas@jonasjaani.se" className="flex items-center space-x-3 text-gray-300 hover:text-blue-400 transition-colors">
                <SafeIcon icon={FiMail} className="w-5 h-5" />
                <span>jonas@jonasjaani.se</span>
              </a>
              <a href="https://linkedin.com/in/jonasjaani" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 text-gray-300 hover:text-blue-400 transition-colors">
                <SafeIcon icon={FiLinkedin} className="w-5 h-5" />
                <span>LinkedIn</span>
              </a>
            </div>
          </motion.div>
        </div>

        {/* Bottom Section */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
          className="border-t border-gray-800 pt-8"
        >
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2026 Jonas Jaani. Alla rättigheter förbehållna.
            </p>
            <div className="flex items-center space-x-2 text-gray-400 text-sm">
              <span>Skapad med</span>
              <SafeIcon icon={FiHeart} className="w-4 h-4 text-red-500" />
              <span>för AI och innovation</span>
            </div>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;